export const corporate = {
  "hero": {
    "title": "Σχετικά με το DONKEY TRAVEL",
    "subtitle": "Ανακαλύψτε την ιστορία μας, το όραμά μας και την παθιασμένη ομάδα που εφευρίσκει εκ νέου την ανταλλαγή στο σπίτι για τους πιο απαιτητικούς οικοδεσπότες."
  },
  "mission": {
    "badge": "Η αποστολή μας",
    "title": "Εκδημοκρατισμός premium peer-to-peer ταξιδιών",
    "description": "Το DONKEY TRAVEL δημιουργήθηκε με μια απλή φιλοδοξία: να επιτρέψει στους καλύτερους επισκέπτες να απολαύσουν επίσης τους καρπούς της εργασίας τους. Πιστεύουμε ότι οι ιδιοκτήτες εξαιρετικών κατοικιών, με βαθμολογία 4,5 και άνω, αξίζουν μια αποκλειστική πλατφόρμα όπου μπορούν να ανταλλάσσουν τα ακίνητά τους με σιγουριά, χωρίς την οικονομική τριβή των παραδοσιακών ενοικιάσεων."
  },
  "philosophy": {
    "badge": "Φιλοσοφία & Αξίες",
    "title": "Στην καρδιά του συλλόγου μας",
    "description": "Δεν είμαστε απλώς μια πλατφόρμα, είμαστε μια κοινότητα που βασίζεται στην εμπιστοσύνη, τον αμοιβαίο σεβασμό και την εξαιρετική φιλοξενία.",
    "values": {
      "fair": {
        "title": "Δικαιοσύνη",
        "desc": "Το σύστημα συναλλαγών μας έχει σχεδιαστεί για να είναι δίκαιο και διαφανές. Προσφέρετε χρόνο στη διαμονή σας, εξοικονομείτε χρόνο για ταξίδια. Είναι απλό, χωρίς κρυφές χρεώσεις."
      },
      "local": {
        "title": "Βύθιση",
        "desc": "Η ανταλλαγή σπιτιών είναι η ευκαιρία να ζήσετε σαν ντόπιοι, να ανακαλύψετε περιοχές εκτός της πεπατημένης διαδρομής και να δημιουργήσετε αυθεντικές συνδέσεις."
      },
      "community": {
        "title": "Εμπιστοσύνη",
        "desc": "Με την κράτηση του κλαμπ μας για επισκέπτες με βαθμολογία 4,5+, εγγυόμαστε ένα άψογο επίπεδο απαιτήσεων και ποιότητας στο δίκτυό μας."
      }
    }
  },
  "team": {
    "badge": "Η ομάδα",
    "title": "Πίσω από το DANKEY TRAVEL",
    "subtitle": "Μια πλατφόρμα που γεννήθηκε από το πάθος για ταξίδια και φιλοξενία.",
    "members": {
      "ceo": {
        "name": "Sylvain",
        "role": "Ιδρυτής & Διευθύνων Σύμβουλος",
        "bio": "Παθιασμένος οικοδεσπότης για χρόνια, ο Sylvain φανταζόταν μόνος του το DONKEY TRAVEL αναζητώντας μια λύση για να ταξιδεύει δωρεάν ενώ παράλληλα προωθούσε το δικό του κατάλυμα. Καθοδηγούμενος από την επιθυμία να δημιουργήσει την καλύτερη ευρωπαϊκή λέσχη ανταλλαγών, διασφαλίζει την αριστεία της κοινότητας καθημερινά."
      }
    }
  },
  "investors": {
    "badge": "Επενδυτές & Συνεργάτες",
    "title": "Λάβετε μέρος στην περιπέτεια",
    "description": "Το DONKEY TRAVEL αναπτύσσεται και είμαστε πάντα ανοιχτοί σε στρατηγικές ευκαιρίες για να επιταχύνουμε την ανάπτυξή μας σε όλη την Ευρώπη.",
    "cta": "Επικοινωνήστε μαζί μας"
  }
};
